module.exports = {
	status: 'ready',
	title: 'Button',
	context: {
		text: 'button',
		classname: '',
	},
};